import React from "react";
import { useState } from "react";
import { AnimatePresence,motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function MissionandVision() {
  const [rippleStyle, setRippleStyle] = useState({});
  const [isAnimating, setIsAnimating] = useState(false);
  const { t }=useTranslation()

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    setRippleStyle({
      top: y,
      left: x,
    });
    setIsAnimating(true);
  };

  const handleMouseLeave = () => {
    setIsAnimating(false);
  };

  return (
    <div className="flex w-full justify-center relative h-[70rem] md:h-[50rem]  py-8">
      <div className="w-full max-w-7xl relative px-4">
        {/* Background Image */}
        <img
          className="w-full h-96 md:h-[35rem] object-cover rounded-lg grayscale hover:grayscale-0"
          src="/assets/firstpageimage.webp"
          alt="Mission and Vision"
        />

        {/* Card Overlay */}
        <div className="absolute right-10 top-80 md:top-20 md:right-20 p-6 md:p-8 rounded-lg  bg-blue-tint text-white md:rounded-lg h-[40rem] w-72 md:shadow-lg">

          <h2 className="text-2xl font-bold mb-4 text-center">
            {t("missionAndVision.settingIndustryStandards")}
          </h2>

          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-2">— {t("missionAndVision.ourMission")}</h3>
            <p className="text-sm leading-6">
              {t("missionAndVision.missionDescription")}
              
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-2">— {t("missionAndVision.ourVision")}</h3>
            <p className="text-sm leading-6">
            {t("missionAndVision.visionDescription")}
            </p>
          </div>

          <Link to="/about">
            <motion.button
              className="mt-4 px-6 py-3 bg-white text-[#00274d] font-semibold rounded hover:bg-gray-100 relative overflow-hidden"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {/* Button Text */}
              <span
              > 
              {t("missionAndVision.learnMore")}
              </span>

              {/* Ripple effect */}
              <AnimatePresence>
                {isAnimating && (
                  <motion.span
                    className="absolute w-4 h-4 rounded-full"
                    style={{
                      top: rippleStyle.top,
                      left: rippleStyle.left,
                      backgroundColor: 'grey', 
                    }}
                    initial={{ scale: 0, opacity: 1 }}
                    animate={{ scale: 20, opacity: 0.5 }} 
                    exit={{ opacity: 0 }} 
                    transition={{ duration: 0.8, ease: 'easeOut' }}
                  />
                )}
              </AnimatePresence>
            </motion.button>
          </Link>
        </div>
      </div>
    </div>
  );
}
